import router from './router'
import { getToken } from '@/utils/auth' // 验权
import i18n from './i18n'
import store from '@/store'
const whiteList = ['/login'] // 不重定向白名单
router.beforeEach(async (to, from, next) => {
  // console.log(getToken())
  const userLanguage = localStorage.getItem('lang') || 'en_US'
  if (userLanguage) {
    i18n.locale = userLanguage
  }
  let isMember = false
  try {
    console.log(to)

    if (JSON.parse(localStorage.getItem('userInfo'))) {
      isMember =
        JSON.parse(localStorage.getItem('userInfo')).vip_status ==
        'inactive_affiliate'
      store.dispatch('Statistics', to.meta.type || '')
    }
  } catch {}

  if (getToken()) {
    if (to.path === '/login') {
      next({ path: '/' })
    } else {
      if (
        to.meta &&
        to.meta.permissions &&
        to.meta.permissions.includes('member')
      ) {
        // console.log(to.meta.permissions, isMember)

        if (isMember) {
          return next(from.path || '/')
        }
      }
      next()
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      if (to.meta.isRegister) {
        return next()
      } else {
        next('/login')
      }
    }
  }
})
